export class ClienteEmpresaEntity{
    constructor(
        public Id?:number,
        public CodCiudadTecni?:number,
        public Identificacion?:string,
        public RazonSocial?:string,
        public ApellidoPaternoRepresentanteLegal?:string,
        public ApellidoMaternoRepresentanteLegal?:string,
        public NombresRepresentanteLegal?:string,
        public ApellidoPaternoContacto?:string,
        public ApellidoMaternoContacto?:string,
        public NombresContacto?:string,
        public EmailPrincipalContacto?:string,
        public CelularPrincipalContacto?:string,
        public CelularSecundarioContacto?:string,
        public TelefonoOficina?:string,
        public ExtensionOficina?:string,
        public CodProvinciaOficina?:number,
        public ProvinciaOficina?:string,
        public CodCiudadOficina?:number,
        public CiudadOficina?:string,        
        public CodSectorOficina?:number,
        public SectorOficina?:string,
        public CallePrincipalOficina?:string,
        public NumeracionOficina?:string,
        public CalleSecundariaOficina?:string    
        ){}
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/datos_generales_empresa_entity.ts